import React, {useState} from "react";
import NetCostReductionChart from "./netCostReductionChart";
import MarginImprovement from "./marginImprovement";
import SalesGrowth from "./salesGrowth";
import MarginValueCapture from "./marginValueCapture";

const Details = (props:any) => {

    const {graphData, goLiveDate, graphData2, page} = props;
   

    return(
        <div className="flex flex-col gap-[4vh] p-[2vh]">
            {page == 'details' && graphData?.map((item:any, k:any)=>{
                return(
             
                <div className="flex gap-[2vh]" key={k}>
                    <div className="flex w-[8vw] items-center">
                        <span className="flex items-center bg-[gray] h-[12vh] px-[2vh] w-full justify-center text-center">
                            {item.supplier}
                        </span>
                    </div>
                    <div className="flex h-[27.5vh]  gap-[4vh] w-full">

                        <NetCostReductionChart
                            chartData={item}
                            goLiveDate={goLiveDate}
                            heading={"Net Cost Reduction"}
                            page = {page}
                        />
                        <MarginImprovement
                            chartData={graphData2[`${item.supplier}`]}
                            goLiveDate={goLiveDate}
                            heading={"Margin Improvement"}
                            page = {page}
                        />

                        <SalesGrowth
                            chartData={item}
                            heading={"Sales Growth"}
                            page = {page}
                        />

                        <MarginValueCapture 
                            chartData={graphData2[`${item.supplier}`]}
                            heading={"Margin Value Capture"}
                            page = {page}
                        />
                    </div>
                </div>
                       
                );
            })
            }
            
        </div>
    );

};
export default Details;